<div
    class="flex flex-col sm:flex-row flex-auto items-center sm:items-start pt-2 pl-2 pr-2"
>
    <div
        class="flex flex-col w-full items-center sm:items-start mt-4 sm:mt-0 sm:pr-8 space-y-1 text-center sm:text-left ng-star-inserted"
    >
        <div class="text-2xl leading-6 font-medium ng-star-inserted">
            Agregar tarjeta de débito o credito
        </div>

        <div class="flex flex-row" style="margin-top: 12px !important">
            <div class="flex flex-row h-6" style="width: 3.5rem">
                <img class="w-full h-full" [src]="'assets/icons/visa.png'" />
            </div>
            <div class="flex flex-row w-16 h-8 ml-4">
                <img
                    class="w-full h-full"
                    [src]="'assets/icons/mastercard.png'"
                />
            </div>
            <div class="flex flex-row w-18 h-7 ml-4">
                <img
                    class="w-full h-full"
                    [src]="'assets/icons/americanExpress.png'"
                />
            </div>
            <div class="flex flex-row h-8 ml-4" style="width: 3.5rem">
                <img class="w-full h-full" [src]="'assets/icons/carnet.png'" />
            </div>
        </div>
        <div class="flex flex-row">
            <div class="flex flex-row w-20 h-6">
                <img class="w-full h-full" [src]="'assets/icons/bbva.png'" />
            </div>
            <div class="flex flex-row w-24 h-7 ml-4">
                <img class="w-full h-full" [src]="'assets/icons/inbursa.png'" />
            </div>
            <div class="flex flex-row w-20 h-7 ml-4">
                <img class="w-full h-full" [src]="'assets/icons/ixe2.jpg'" />
            </div>
        </div>
        <div class="flex flex-row">
            <div class="flex flex-row w-24 h-7">
                <img
                    class="w-full h-full"
                    [src]="'assets/icons/santander.jpg'"
                />
            </div>
            <div class="flex flex-row w-24 h-7 ml-4">
                <img
                    class="w-full h-full"
                    [src]="'assets/icons/scotiabank.png'"
                />
            </div>
            <div class="flex flex-row w-20 h-8 ml-4">
                <img class="w-full h-full" [src]="'assets/icons/hsbc.jpg'" />
            </div>
        </div>

        <form [formGroup]="tarjetaForm" class="w-full" fxLayout="column">
            <mat-form-field class="w-full">
                <mat-label> Nombre del titular de la tarjeta </mat-label>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-5 w-5 fill-primary mr-2"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                >
                    <path
                        fill-rule="evenodd"
                        d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                        clip-rule="evenodd"
                    />
                </svg>
                <input
                    id="nombre"
                    matInput
                    [formControlName]="'nombre'"
                    placeholder="Nombre del titular"
                />
            </mat-form-field>
            <div
                class="help is-danger"
                *ngIf="
                    tarjetaForm.controls.nombre.invalid &&
                    (tarjetaForm.controls.nombre.dirty ||
                        tarjetaForm.controls.nombre.touched)
                "
            >
                Nombre del titular requerido
            </div>
            <mat-form-field class="w-full">
                <mat-label> Número de tarjeta </mat-label>
                <div
                    fxLayout="row"
                    fxFlex="100"
                    fxLayoutAlign="space-between center"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-5 w-5 fill-primary mr-2"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                    >
                        <path d="M4 4a2 2 0 00-2 2v1h16V6a2 2 0 00-2-2H4z" />
                        <path
                            fill-rule="evenodd"
                            d="M18 9H2v5a2 2 0 002 2h12a2 2 0 002-2V9zM4 13a1 1 0 011-1h1a1 1 0 110 2H5a1 1 0 01-1-1zm5-1a1 1 0 100 2h1a1 1 0 100-2H9z"
                            clip-rule="evenodd"
                        />
                    </svg>

                    <input
                        id="num"
                        matInput
                        [formControlName]="'num'"
                        placeholder="Número de tarjeta"
                        (input)="onCardNumberInput()"
                        [maxlength]="cardNumberMaxLength"
                        inputmode="numeric"
                        style="flex-grow: 1"
                    />

                    <div class="h-10">
                        <img
                            *ngIf="cardTypeImage"
                            [src]="cardTypeImage"
                            class="w-full h-full ml-2"
                            alt="Tipo de tarjeta"
                        />
                    </div>
                </div>
            </mat-form-field>
            <div
                class="help is-danger"
                *ngIf="
                    tarjetaForm.controls.num.invalid &&
                    (tarjetaForm.controls.num.dirty ||
                        tarjetaForm.controls.num.touched)
                "
            >
                <div *ngIf="tarjetaForm.controls.num.errors?.['required']">
                    Número de tarjeta requerido.
                </div>
                <div
                    *ngIf="tarjetaForm.controls.num.errors?.['requiredLength']"
                >
                    Número de tarjeta inválido.
                </div>
            </div>

            <mat-form-field class="w-6/12">
                <mat-label>Mes y año de vigencia</mat-label>
                <input matInput [mask]="'M0/00'" formControlName="expiration" />
                <mat-hint>MM/YY</mat-hint>
            </mat-form-field>
            <div
                class="help is-danger"
                *ngIf="
                    tarjetaForm.controls.expiration.invalid &&
                    (tarjetaForm.controls.expiration.dirty ||
                        tarjetaForm.controls.expiration.touched)
                "
            >
                <div
                    *ngIf="tarjetaForm.controls.expiration.errors?.['required']"
                >
                    Fecha de expiración es requerida
                </div>
                <div
                    *ngIf="tarjetaForm.controls.expiration.errors?.['pattern']"
                >
                    Fecha inválida
                </div>
            </div>

            <mat-form-field class="sm:w-4/12 lg:w-3/12 xl:w-3/12 2xl:w-3/12">
                <mat-label> CVV </mat-label>
                <input
                    id="cvv"
                    matInput
                    [formControlName]="'cvv'"
                    placeholder="CVV"
                    (input)="onCvvInput()"
                    inputmode="numeric"
                    [maxlength]="cvvMaxLength"
                />
                <button
                    mat-icon-button
                    [matTooltip]="'3 o 4 dígitos al reverso de la tarjeta'"
                    style="width: 30px !important"
                >
                    <mat-icon
                        matSuffix
                        class="icon-size-5 text-current"
                        [svgIcon]="'heroicons_solid:information-circle'"
                    ></mat-icon>
                </button>
            </mat-form-field>
            <div
                *ngIf="
                    tarjetaForm.controls.cvv.invalid &&
                    (tarjetaForm.controls.cvv.dirty ||
                        tarjetaForm.controls.cvv.touched)
                "
            >
                <div
                    class="help is-danger"
                    *ngIf="tarjetaForm.controls.cvv.errors?.['cvvLength']"
                >
                    CVV debe tener
                    {{ tarjetaForm.controls.cvv.errors?.['cvvLength'].requiredLength }}
                    dígitos.
                </div>
            </div>
        </form>
        <div class="flex flex-row">
            <div class="text-base leading-6 font-medium ng-star-inserted">
                Transacciones realizadas vía:
            </div>
            <div class="flex flex-row" class="w-16 h-5 mt-1 ml-1">
                <img class="w-full h-full" [src]="'assets/icons/openpay.png'" />
            </div>
        </div>
        <div class="flex flex-row">
            <div class="text-xs leading-6 font-normal ng-star-inserted">
                Tus pagos se realizan de forma segura con encriptación de 256
                bits.
            </div>
        </div>
        <div
            class="flex items-end w-full content-end justify-end sm:justify-end space-x-3 ng-star-inserted"
        >
            <button
                mat-flat-button
                class="mat-focus-indicator mat-flat-button mat-button-base text-white ng-star-inserted"
                style="background-color: red !important"
                type="button"
                (click)="close()"
            >
                Cancelar
            </button>
            <button
                mat-flat-button
                class="mat-focus-indicator mat-flat-button mat-button-base bg-green-500 hover:bg-green-600 text-white ng-star-inserted"
                (click)="onSave()"
                [disabled]="!tarjetaForm.valid"
                type="button"
            >
                Confirmar
            </button>
        </div>
    </div>
</div>
